import React from "react";

function Personal() {
  return (
    <div className="per">
      <h2>
        <b>Certificates</b>
      </h2>

      <p>
        SQL (Basic): Awarded by HackerRank for advanced querying and database expertise.{" "}
        <a
          href="https://www.hackerrank.com/certificates/bad556b98c08"
          target="_blank"
          rel="noopener noreferrer"
        >
          View
        </a>
      </p>

      <p>
        SQL Course Completion: Certified by Oracle Academy for excellence in database programming.{" "}
        <a
          href="https://drive.google.com/file/d/1lAZWxrpvdXAMCEApsQOL2VngpPTRv7V2/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          View
        </a>
      </p>

      <p>
        PL/SQL Course Completion: Awarded by Oracle Academy for advanced procedural programming skills.{" "}
        <a
          href="https://drive.google.com/file/d/1QKDoGN8sTb6sVsgPMYEBl4_bfUs-9W1F/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          View
        </a>
      </p>

      <p>
        Database Design Certification: Granted by Oracle Academy for expertise in database architecture.{" "}
        <a
          href="https://drive.google.com/file/d/1P_vpvcGdIuv5TcNNVewaCEOARGs3qJry/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          View
        </a>
      </p>

      <p>
        Problem Solving through Programming in C Certification: Granted by NPTEL.{" "}
        <a
          href="https://drive.google.com/file/d/1-VW73nRAsVqYfEZxuxDQmA8sufkBduXT/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          View
        </a>
      </p>
    </div>
  );
}

export default Personal;
